import { render, staticRenderFns } from "./TenantApps.vue?vue&type=template&id=18be88a4&"
import script from "./TenantApps.vue?vue&type=script&lang=js&"
export * from "./TenantApps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports